<nz-card class="max-h-[calc(100vh-200px)]">
  <nz-page-header class="pb-4 pt-0 px-0">
    <nz-page-header-title class="text-base">Training Videos</nz-page-header-title>
    <nz-page-header-extra>
      <button nz-button nzType="default" nzShape="circle" (click)="getDemoVideos()">
        <i nz-icon nzType="reload" nzTheme="outline" nz-tooltip nzTooltipTitle="Refresh" nzTooltipPlacement="top" nzTooltipColor="#fff"></i>
      </button>
    </nz-page-header-extra>
  </nz-page-header>

  <nz-tabset [(nzSelectedIndex)]="activeTab" (nzSelectedIndexChange)="onTabChange($event)">
    <nz-tab nzTitle="Software Videos">
      <ng-template nz-tab>
        <ng-container *ngTemplateOutlet="tableTemplate; context: { list: softwareVideos }"></ng-container>
      </ng-template>
    </nz-tab>
    <nz-tab nzTitle="Hardware Videos">
      <ng-template nz-tab>
        <ng-container *ngTemplateOutlet="tableTemplate; context: { list: hardwareVideos }"></ng-container>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</nz-card>

<ng-template #tableTemplate let-list="list">
  <nz-table
    #table
    [nzLoading]="isTableLoading"
    [nzShowPagination]="true"
    [nzFrontPagination]="true"
    [nzPageSize]="paginationConfig['pageSize']"
    [nzPageIndex]="paginationConfig['pageIndex']"
    [nzSize]="'small'"
    [nzShowTotal]="totalTemplate"
    [nzShowSizeChanger]="true"
    [nzTotal]="list.length"
    [nzData]="list"
    [nzScroll]="{y:'calc(100vh - 500px)', x:'800px'}"
    (nzQueryParams)="onQueryParamsChange($event)"
    class="w-full resources-table">
    <thead>
      <tr>
        <th nzWidth="60px">Sr.</th>
        <th nzWidth="200px">Title</th>
        <th nzWidth="300px">Description</th>
        <th nzWidth="100px" nzRight>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of table.data; let i = index; trackBy: feUtil.trackByFn">
        <td>{{ (paginationConfig['pageIndex'] - 1) * paginationConfig['pageSize'] + i + 1 }}</td>
        <td nzEllipsis>{{ data.title }}</td>
        <td nzEllipsis>{{ data.description }}</td>
        <td nzRight>
          <button nz-button nzType="primary" nzShape="circle" nzSize="small" (click)="viewTicket(data, viewResourceModal)">
            <i nz-icon nzType="play-circle" nzTheme="outline"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</ng-template>

<ng-template #viewResourceModal>
  <div class="video-container">
    <ng-container *ngIf="resources && resources.fileLocation; else noVideo">
      <div class="video-player-wrapper relative">
        <video
          #videoPlayer

          [src]="resources.fileLocation"
          controls
          controlsList="nodownload"
          oncontextmenu="return false;"
          class="w-full rounded shadow-lg"
          preload="metadata">
          <track kind="captions" src="" label="English" default>
          Your browser does not support the video tag.
        </video>
      </div>
    </ng-container>
    <ng-template #noVideo>
      <nz-result
        nzStatus="warning"
        nzTitle="Video Not Available"
        nzSubTitle="The requested training video could not be loaded.">
        <div nz-result-extra>
          <button nz-button nzType="primary" (click)="getDemoVideos()">Refresh</button>
        </div>
      </nz-result>
    </ng-template>
  </div>
</ng-template>

<ng-template #totalTemplate let-total>Total {{ total }} items</ng-template>
